// The headline figures above each Inbounds/Outbounds tab's table; only Inventory draws them.

export const CONTRACTS_STRIP_QUERY = `
  query ContractsStrip($filters: ContractFilters, $search: ContractSearch) {
    contractsSummary(filters: $filters, search: $search) {
      workingUnit
      declarationUnit
      totalContractedQuantityWorking totalContractedQuantityDeclaration
      totalShippedQuantityWorking totalShippedQuantityDeclaration
      totalOutstandingQuantityWorking totalOutstandingQuantityDeclaration
    }
  }
`;

export const SHIPMENTS_STRIP_QUERY = `
  query ShipmentsStrip($filters: ShipmentFilters, $search: ShipmentSearch) {
    shipmentsSummary(filters: $filters, search: $search) {
      workingUnit
      declarationUnit
      totalShipmentQuantityWorking totalShipmentQuantityDeclaration
      totalReceivedDeclarationQuantityWorking totalReceivedDeclarationQuantityDeclaration
      totalPendingShipmentQuantityWorking totalPendingShipmentQuantityDeclaration
      totalAvailableShipmentQuantityWorking totalAvailableShipmentQuantityDeclaration
    }
  }
`;

export const DECLARATIONS_STRIP_QUERY = `
  query DeclarationsStrip($certificateType: CertificateType, $filters: DeclarationFilters, $search: DeclarationSearch) {
    declarationsSummary(certificateType: $certificateType, filters: $filters, search: $search) {
      workingUnit
      declarationUnit
      trackingUnit
      totalReceivedQuantityWorking totalReceivedQuantityDeclaration totalReceivedQuantityTracking
      totalAdjustedQuantityWorking totalAdjustedQuantityDeclaration totalAdjustedQuantityTracking
      totalAvailableQuantityWorking totalAvailableQuantityDeclaration totalAvailableQuantityTracking
    }
  }
`;

export const ORDERS_STRIP_QUERY = `
  query OrdersStrip($filters: PendingOrderFilters, $search: PendingOrderSearch) {
    ordersSummary(filters: $filters, search: $search) {
      workingUnit
      declarationUnit
      totalContractedQuantityWorking totalContractedQuantityDeclaration
      totalShippedQuantityWorking totalShippedQuantityDeclaration
      totalAllocatedQuantityWorking totalAllocatedQuantityDeclaration
      totalRemainingToAllocateQuantityWorking totalRemainingToAllocateQuantityDeclaration
    }
  }
`;

export const OUTGOING_SHIPMENTS_STRIP_QUERY = `
  query OutgoingShipmentsStrip($certificateType: CertificateType, $filters: OutgoingShipmentFilters, $search: OutgoingShipmentSearch) {
    outgoingShipmentsSummary(certificateType: $certificateType, filters: $filters, search: $search) {
      workingUnit
      declarationUnit
      totalShipmentQuantityWorking totalShipmentQuantityDeclaration
      totalAllocatedQuantityWorking totalAllocatedQuantityDeclaration
      totalRemainingToAllocateQuantityWorking totalRemainingToAllocateQuantityDeclaration
    }
  }
`;

export const ALLOCATIONS_STRIP_QUERY = `
  query AllocationsStrip($certificateType: CertificateType, $filters: FulfillmentFilters, $search: FulfillmentSearch) {
    allocationsSummary(certificateType: $certificateType, filters: $filters, search: $search) {
      workingUnit
      declarationUnit
      totalAllocatedQuantityWorking totalAllocatedQuantityDeclaration
    }
  }
`;
